import React from 'react';
import Aux from './Aux';
import Header from '../HeaderFooter/Header';
import Footer from '../HeaderFooter/Footer';

const Layout = ({ children }) => {
    const isContactPage = window.location.pathname === '/contact';

    return (
        <div>
            <Header />
            <Aux>{children}</Aux>
            {!isContactPage && <Footer />}
        </div>
    );
};

export default Layout;
